import { useBoolean } from 'usehooks-ts';

export const useModal = (defaultValue: boolean) => {
  const { value, setTrue, setFalse } = useBoolean(defaultValue);
  return { isOpen: value, setOpen: setTrue, setClose: setFalse };
};
